import script from "./AlertBox.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertBox.vue?vue&type=script&setup=true&lang=js"

import "./AlertBox.vue?vue&type=style&index=0&id=90a3c922&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90a3c922"]])

export default __exports__